import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";

const IdentificationSummary = ({ partner, partnerTypes, basePFTypeId }) => {
  const { t } = useTranslation();

  const [partnerTypeName, setPartnerTypeName] = useState(null);
  useEffect(() => {
    const partnerType = partnerTypes.find(x => x.partnerTypeId === partner.partnerTypeId);
    if (partnerType != null) {
      setPartnerTypeName(partnerType.partnerTypeName);
    } else {
      setPartnerTypeName("");
    }
  }, [partner.partnerTypeId, partnerTypes]);

  return (
    <Grid container spacing={1} sx={{ fontSize: "14px" }}>
      <Grid item xs={12} sm={4}>
        <strong>{t("Partner.PartnerType")}</strong> : {<span>{partnerTypeName}</span>}
      </Grid>
      <Grid item xs={12} sm={4}>
        <strong>{t("Partner.Name")}</strong> : <span>{partner.partnerName}</span>
      </Grid>
      <Grid item xs={12} sm={4}>
        <strong>
          {(partner.partnerTypeId & basePFTypeId) === basePFTypeId
            ? t("Partner.PersonUniqueID")
            : t("Partner.CompanyUniqueID")}
        </strong>{" "}
        : <span>{partner.uniqueId}</span>
      </Grid>
    </Grid>
  );
};

IdentificationSummary.propTypes = {
  partner: PropTypes.object.isRequired,
  partnerTypes: PropTypes.array.isRequired,
  basePFTypeId: PropTypes.number
};

export default IdentificationSummary;
